<template>
    <div class="view" :style="{paddingTop:barh(100)}">
        <div class="content">
            <my-top title="待办" lefttext="返回"></my-top>
            <div class="screenbox" :style="{top:navbarheight}">
                <tabs class="sarchtabs" @change="clicktabs">
                    <tab v-for="item in approvallist" :title="item.name" :key="item.id"></tab>
                </tabs>
            </div>
            <pull-refresh>
                    <!--v-model="refreshing">-->
                    <!--@refresh="onRefresh">-->
                <list
                        class="cont-box"
                        finished-text="没有更多了">
                        <!--@load="getData">-->
                    <!--<div class="item-box" v-for="item in list" :key="item.id">-->
                    <div class="item-box">
                        <cell title="title">qwe</cell>

                    </div>
                </list>
            </pull-refresh>
        </div>
    </div>
</template>

<script>
    import {Step, Steps, Tabs, Tab, Swipe, SwipeItem, Search, Popup, Picker, List, PullRefresh } from 'vant';
    import application from '@api/application';
    import { getToken } from "@/libs/util";
    export default {
        name:'approval',
        components: {
            Step,
            Steps,
            Tabs,
            Tab,
            Swipe,
            SwipeItem,
            Search,
            Popup,
            Picker,
            List,
            PullRefresh
        },
        data() {
            return {
                title: this.$route.query.title,
                key: this.$route.query.key,
                token: this.$store.state.user.token,
                approvallist: [
                    {name:'全部',id:''},
                    {name:'我发起的',id:''},
                    {name:'已处理',id:''},
                    {name:'抄送我的',id:''},
                ],
                query: {
                    pageNo: 1,
                    pageSize: 5,
                    needCount: true,
                    query: {
                        projectId: this.$store.state.project.projectId,
                        cate: parseInt(this.$store.state.project.key),
                        content: '',
                    }
                },

                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                columns: [],
                screen: this.$route.query.screen,
                qualityquery: this.$store.state.project.qualityquery,

            }
        },
        created(){
            // if (this.$store.state.project.key === 0) {
            //
            // }  else if (this.$store.state.project.key === 1){
            //
            // }
        },
        computed: {
            transformationdata() {
                let quality = this.$storeLocal.get('quality_inspect'), newarr = [];
                if(quality && quality.length>0) {
                    quality.map(item=> {
                        let params = {
                            id: item.id,
                            localPreservation: true,
                            subProject: item.subProjectTypetext,
                            rectifier: item.rectifiertext,
                            problemType: {name: item.problemTypename},
                            checkDate: item.rectifyTermtext,
                            project: item.subProjectTypetext,
                            employee: item.reCheckname,
                            rectifierCompany: item.companyname,
                            files: item.fileList,
                        }
                        newarr.push(params);
                    })
                }
                return newarr;
            }
        },
        methods: {
            confirm(data) {
                this.showPicker = false;
                this.togo('/project/qtaddinspect',{id:data.id, projectId: this.$store.state.project.projectId, title:this.title});
            },
            getlistdata(type='add') {
                if(this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(type=='new') {
                    this.list = [];
                    this.query.pageNo=1;
                    this.loading = true;
                    this.finished = false;
                }
                application.approvallist(this.query).then(res=> {
                    if(res.code==200) {
                        this.list = this.list.concat(res.data);
                        this.query.pageNo++;
                        this.loading = false;
                        if(res.currentPage>=res.totalPage) {
                            this.finished = true;
                        }
                    }
                }).catch(err => {

                })
            },
            searchLoad() {
                this.getlistdata('new');
            },
            onRefresh() {
                this.getlistdata('new');
                this.finished = false;
                this.loading = true;
            },
            clicktabs(index) {
                if(index !== 0){
                    this.query.query.statusIds = [this.approvallist[index].id];
                }else {
                    this.query.query.statusIds = [];
                }
                this.getlistdata('new');
            }
        },
        mounted() {
            // if(this.screen) {
            //     Object.assign(this.query.query, this.$store.state.project.qualityquery);
            // }
            // project.qualitytype({query:{labelType: '3'}}).then(res=> {
            //     if(res.code === 200){
            //         this.approvallist = [{name:'全部',id:''}].concat(res.data);
            //     }else {
            //         this.$toast(res.message)
            //     }
            // });
        }
    }
</script>

<style lang="scss" scoped>
    .view {
        .content {
            padding-bottom: 50px;
            .screenbox {
                width: 100%;
                position: fixed;
                left: 0;
                z-index: 2;
                .sarch {
                    ::v-deep .van-search {
                        .van-search__content {
                            border-radius: 20px;
                        }
                    }
                }
                .sarchtabs {
                    ::v-deep .van-tabs__line {
                        background-color: #018fe0;
                        bottom: 18px;
                    }
                }
            }
            .cont-box {
                padding: 1rem;
                .item-box {
                    margin-bottom: 10px;
                    overflow: hidden;
                }

            }
        }

        .btn {
            > span:first-child {
                background-color: #70B603;
            }
            > span:last-child {
                background-color: #169BD5;
            }
        }
    }

</style>
